import { apiClient } from "../lib/api";

export const timekeepingApi = {
  getFeatureFlags: () => apiClient.get("/timekeeping/feature-flags"),
  testDriveConnection: () => apiClient.post("/timekeeping/sources/connection-test"),

  listBatches: () => apiClient.get("/timekeeping/imports/batches"),
  runFixtureDiscovery: (payrollMonth) => apiClient.post("/timekeeping/imports/fixture-discovery", null, { params: { payroll_month: payrollMonth } }),
  uploadZip: (file, payrollMonth) => {
    const form = new FormData();
    form.append("file", file);
    if (payrollMonth) form.append("payroll_month", payrollMonth);
    return apiClient.post("/timekeeping/imports/zip-upload", form, { headers: { "Content-Type": "multipart/form-data" } });
  },

  listFiles: (payrollMonth, processingStatus) => apiClient.get("/timekeeping/imports/files", { params: { payroll_month: payrollMonth || undefined, processing_status: processingStatus || undefined } }),
  getFile: (id) => apiClient.get(`/timekeeping/imports/files/${id}`),
  getFileImageUrl: (id) => `${apiClient.defaults.baseURL}/timekeeping/imports/files/${id}/image`,
  extractFile: (id) => apiClient.post(`/timekeeping/imports/files/${id}/extract`),

  runPairing: (payrollMonth) => apiClient.post("/timekeeping/pairing/run", null, { params: { payroll_month: payrollMonth } }),
  listPairs: (payrollMonth) => apiClient.get("/timekeeping/pairing", { params: { payroll_month: payrollMonth || undefined } }),
  confirmPair: (pairId, payload) => apiClient.post(`/timekeeping/pairing/${pairId}/confirm`, payload),
  rejectPair: (pairId, reason) => apiClient.post(`/timekeeping/pairing/${pairId}/reject`, { reason }),

  getMonthDashboard: (payrollMonth) => apiClient.get(`/timekeeping/monthly/${payrollMonth}`),

  getEmployeeMonthReview: (employeeId, payrollMonth) => apiClient.get(`/timekeeping/review/${employeeId}`, { params: { payroll_month: payrollMonth } }),
  correctDay: (employeeId, payload) => apiClient.post(`/timekeeping/review/${employeeId}/correct`, payload),
  approveMonth: (employeeId, payrollMonth) => apiClient.post(`/timekeeping/review/${employeeId}/approve-month`, null, { params: { payroll_month: payrollMonth } }),
  lockMonth: (employeeId, payrollMonth) => apiClient.post(`/timekeeping/review/${employeeId}/lock`, null, { params: { payroll_month: payrollMonth } }),
  reopenMonth: (employeeId, payrollMonth, reason) => apiClient.post(`/timekeeping/review/${employeeId}/reopen`, { reason }, { params: { payroll_month: payrollMonth } }),
};
